import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
// @ts-ignore untyped module
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { createGetBusinessUnitDisplaysForUser, getBusinessUnitDisplaysForUser } from '../api/BusinessUnitDropdownChirpAPI';
export const createBusinessUnitDropdownReferenceResolverChirp = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.BUSINESS_UNIT_DROPDOWN,
  createFetchData: ({
    httpClient
  }) => createGetBusinessUnitDisplaysForUser({
    httpClient
  }),
  fetchData: getBusinessUnitDisplaysForUser
}, options));
export default createBusinessUnitDropdownReferenceResolverChirp();